import React from "react";

type PillTabProps = {
  label: string;
  isActive: boolean;
  onClick: () => void;
  className?: string;
};

const PillTab: React.FC<PillTabProps> = ({
  label,
  isActive,
  onClick,
  className = "",
}) => {
  return (
    <button
      type="button"
      aria-pressed={isActive}
      onClick={onClick}
      className={`inline-flex items-center justify-center min-w-[74px] h-[40px] px-6 py-2.5 rounded-full border text-body-sm-emphasis transition-all ${
        isActive
          ? "bg-border text-text-heading border-border"
          : "bg-white text-text-muted border-border hover:bg-border/50"
      } ${className}`}
    >
      {label}
    </button>
  );
};

export default PillTab;
